import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import InputField from "./elements/InputField";
import emailjs from "emailjs-com";
import {
  Controller,
  FormProvider,
  useForm,
  useFormContext,
} from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Card from "./elements/Card";
import Popup from "./elements/Popup";

const ContactUs = () => {
  const methods = useForm();
  const navigate = useNavigate();
  const [isEmailSending, setFormSending] = useState(false);
  const [isFinish, setFinish] = useState(false);
  const [error, setError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  /*  const {
    control,
    formState: { errors },
  } = useFormContext(); */
  const onError = () => {
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };
  const onSubmit = async (data) => {
    //console.log(data);
    setFormSending(true);
    try {
      await emailjs.send(
        "service_29v5u8h",
        "template_w1p319n",
        data,
        "8rjrcUKtlnVKcPtOO"
      );

      setFinish(true);
    } catch (error) {
      setError(true);
      setFinish(true);
    }
    setFormSending(false);
  };
  const centeredRef = useRef(null);

  const handleClickOutside = (event) => {
    if (centeredRef.current && !centeredRef.current.contains(event.target)) {
      setFinish(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div>
      <Popup
        message="لطفا خطاهای موجود در فرم را برطرف کنید."
        show={showPopup}
        onClose={() => setShowPopup(false)}
      />
      {(isFinish || error) && (
        <Card
          ref={centeredRef}
          setFinish={setFinish}
          error={error}
          setError={setError}
        />
      )}
      {(isFinish || error) && (
        <div
          onClick={() => {
            setFinish(false);
          }}
          class="fixed z-20 bg-white backdrop-blur-sm bg-opacity-30  w-full h-full inset-0"
        ></div>
      )}
      <Header />

      <div className=" mx-auto max-w-5xl">
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit, onError)}
            className=" max-w-5xl  p-4 pb-4 bg-white mt-4 border-2 rounded-lg mx-6"
          >
            <div className="relative  rounded-xl border-2 bg-white border-white p-4 ">
              <h1 className=" text-right  text-xl mb-12 font-semibold">
                تماس با ما
              </h1>
              <InputField
                rules={{ required: "لطفا این فیلد را تکمیل نمالید." }}
                type="text"
                label="موضوع"
                name="subject"
              />
              <InputField
                rules={{ required: "لطفا این فیلد را تکمیل نمالید." }}
                type="text"
                label="نام و نام خانوادگی"
                name="name"
              />
              <InputField
                rules={{
                  required: "لطفا این فیلد را تکمیل نمایید.",
                  pattern: {
                    value: /^[+-]?\d+$/,
                    message: "لطفا شماره تماس معتبر وارد کنید.",
                  },
                }}
                type="text"
                label="شماره تماس"
                name="mobile"
                convertToLatin={true}
              />
              <InputField
                rules={{
                  required: "لطفا این فیلد را تکمیل نمالید.",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "ایمیل معتبر نیست",
                  },
                }}
                type="email"
                label="ایمیل"
                name="email"
              />

              <InputField
                rules={{
                  required: "لطفا این فیلد را تکمیل نمالید.",
                }}
                type="text"
                label="پیام"
                name="description"
                textarea={true}
              />
            </div>
            <div className="flex justify-between w-full">
              <button
                className={`  
         text-lg border-buttonGray border-2  text-gray-800   px-6  py-2  w-32 rounded-lg flex items-center  cursor-pointer   font-bold  transition-all duration-200   z-10 hover:bg-buttonGray ${
           isEmailSending && "opacity-50 cursor-progress border-buttonGray"
         }`}
                type="button"
                disabled={isEmailSending ? true : false}
              >
                <span
                  className=" mx-auto text-gray-500"
                  onClick={() => navigate("/")}
                >
                  بازگشت
                </span>
              </button>
              <button
                className={` border-bgBlue border-2 
         text-lg hover:bg-bgHoverBlue   text-white px-6  py-2  w-32 rounded-lg flex items-center  cursor-pointer   font-bold  transition-all duration-200  bg-bgBlue ${
           isEmailSending && "bg-bgHoverBlue cursor-progress opacity-50"
         } `}
                type="submit"
                disabled={isEmailSending ? true : false}
              >
                {isEmailSending ? (
                  <div className="flex items-center justify-center mx-auto">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white-500"></div>
                  </div>
                ) : (
                  <span className=" mx-auto">ثبت</span>
                )}
              </button>
            </div>
          </form>
        </FormProvider>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
